
    const data = {"name":"src/core/icons/flag-dk","data":{"viewBox":"0 0 370 280","data":"<path pid=\"0\" _fill=\"#c60c30\" d=\"M0 0h370v280H0z\"/><path pid=\"1\" _fill=\"#fff\" d=\"M120 0h40v280h-40z\"/><path pid=\"2\" _fill=\"#fff\" d=\"M0 120h370v40H0z\"/>","originalColors":[{"type":"fill","color":"#c60c30"},{"type":"fill","color":"#fff"},{"type":"fill","color":"#fff"}],"stopColors":[]}}

            export default data
            